<template>
  <div>
    <div class="columns is-multiline" v-if="value!==undefined">
      <div class="column is-half">
        <div class="box" style="position:relative">
          <div class="button-save button is-primary" @click.stop.prevent="clickSave">저장하기</div>
          <admin-box-item title="서비스 정보">
            <admin-form-item label="서비스 종류">
              <div v-if="value.request_type===0">테마</div>
              <div v-if="value.request_type===1">선주문 테마</div>
            </admin-form-item>

            <admin-form-item label="서비스명">
              {{ value.service_name }}
            </admin-form-item>

            <admin-form-item label="서비스키">
              {{ value.key }}
            </admin-form-item>

            <admin-form-item label="연결된 도메인">
              {{ value.domain }}
            </admin-form-item>

            <admin-form-item label="사용자명">
              {{ value.service_user.name }}
            </admin-form-item>

            <admin-form-item label="서비스 상태">
              {{ getServiceStatus(value.status) }}
            </admin-form-item>

            <!-- 서비스 복구(중단 되어 있을 경우만 가능) -->
            <admin-form-item label="서비스 복구하기">
              <div v-if="value.status===99">
                <button class="button" @click="serviceRecover">서비스 복구</button>
              </div>
              <div v-else>-</div>
            </admin-form-item>

            <!-- 배포 업데이트(백엔드 코드 재배포) -->
            <admin-form-item label="서버 재배포" v-if="value.status===9">
              <button class="button" @click="deployServer">서버 재배포하기</button>
            </admin-form-item>

            <admin-form-item label="담당자 지정">
              <span class="select">
                <select v-model="value.manager_id" @change="selectManager">
                  <option value="" disabled selected>담당자 지정</option>
                  <option :value="item.value" v-for="(item, idx) in managerList" :key="'status-'+idx">{{ item.label }}</option>
                </select>
                </span>
            </admin-form-item>

            <admin-form-item label="추가서비스 이용 상태" style="margin-top:20px">
              <div class="grid-service">
                <div v-for="(item,idx) in addServices" :key="'add-service-'+idx" class="add-service">
                  <div class="add-service-title">{{ item.name }}</div>
                  <select v-model="item.status">
                    <option :value="0">추가</option>
                    <option :value="1">이용중</option>
                  </select>
                </div>
              </div>
            </admin-form-item>

          </admin-box-item>
        </div>
      </div>
      <div class="column is-half" v-if="value.talk && value.talk > 0">
        <launch-talk :talkId="value.talk"></launch-talk>
      </div>
    </div>

  </div>
</template>

<script>
  import LaunchTalk from "../../../module/common/LaunchTalk";
  export default {
    name: "service-update",
    components: {LaunchTalk},
    data() {
      return {
        value: undefined,
        statusOptions: [
          {value: 0, label: '결제요청'},
          {value: 1, label: '결제완료'},
          {value: 2, label: '개설중(DB설치)'},
          {value: 3, label: '개설중(백엔드설치)'},
          {value: 4, label: '개설중(프론트엔드설치)'},
          {value: 9, label: '서비스 중'},
          {value: 99, label: '서비스 중단'}
        ],
        managerList: [],
        addServices: [],
        orders: []
      }
    },
    created() {
      this.getData();
      this.getManager();
      this.getAddService();
    },
    methods: {
      async clickSave() {
        console.log('clickSave')
        let services = this.addServices.filter(i => {
          if(i.status === 1) {
            return this.orders.findIndex(o => { return o.product.id === i.id }) === -1;
          } else {
            return false;
          }
        });
        for(let service of services) {
          await this.$axios.post(`admin/launchpack/service/${this.$route.query.id}/app_order`, {
            "pay_type": 0,
            "status": 2,
            "product": {
              "product_id": service.id
            }
          });
        }
        if(services.length > 0) {
          this.getAddService();
        }
      },
      getAddService() {
        this.$axios.get(`admin/product?is_parent=true&cur_page=1&page_num=1&page_length=100&is_partner=false&cat1=46&cat2=49&cat3=`).then(res=>{
          this.$axios.get(`admin/launchpack/service/${this.$route.query.id}/app_order?category=49&status=2`).then(order_res=>{
            this.orders = order_res.data;
            this.addServices = res.data.data.map(i=>{
              let status = order_res.data.findIndex(o => { return o.product.id === i.id }) > -1 ? 1 : 0;
              return {
                id: i.id,
                name: i.name,
                status: status
              }
            });
          });
        });
      },
      selectManager(e) {
        let manager_id = parseInt(e.target.value);
        this.$axios.post(`admin/launchpack/service/${this.$route.query.id}/add_manager`, {
          manager_id: manager_id
        }).then(res=>{
          this.toast('담당자가 지정되었습니다.');
        })
      },
      getData() {
        this.$axios.get(this.getUrl(`launchpack/service/${this.$route.query.id}`)).then(res=> {
          if(res.status===200) {
            this.value = res.data;
          }
        })
      },
      getServiceStatus(value) {
        for(let status of this.statusOptions) {
          if(status.value===value) {
            return status.label;
          }
        }
      },
      serviceRecover() {
        this.$store.commit('setLoading', true);
        this.$axios.patch(this.getUrl(`launchpack/service/${this.$route.query.id}/recover`)).then(res=> {
          if(res.status===200) {
            this.$store.commit('setLoading', false);
            this.$router.replace(this.getPath('launchpack/service'));
            this.toast('서비스가 복구되었습니다.');
          }
        }).catch(error=>{
          this.$store.commit('setLoading', false);
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      deployServer() {
        this.$store.commit('setLoading', true);
        this.$axios.patch(this.getUrl(`launchpack/service/${this.$route.query.id}/cluster/update`)).then(res=> {
          if(res.status===200) {
            this.$store.commit('setLoading', false);
            this.$router.replace(this.getPath('launchpack/service'));
            this.toast('서버 재배포가 완료되었습니다.');
          }
        }).catch(error=>{
          this.$store.commit('setLoading', false);
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      getManager() {
        this.$axios.get('admin/admin/normal').then(res=> {
          this.managerList = res.data;
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .grid-service
    display grid
    grid-template-columns repeat(3, 1fr)
    grid-column-gap 16px
    grid-row-gap 8px

  .add-service
    display flex
    align-items center
    justify-content space-between

  .add-service-title
    margin-right 4px
    font-size 12px

  select
    border 1px solid #dddddd
    padding 4px 8px
    border-radius 4px
  .button-save
    position absolute
    top 80px
    right 16px
    z-index 99
</style>
